import { Icon } from "antd";
import moment from "moment";
import React, { Component } from "react";
import LangContext from "../contextProvider/LangContext";



class DashboardDateChecker extends Component {

    constructor(props) {
        super(props)

        this.state = { value: new Date() }
        this.changeRun = null
    }



    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidMount() {
        this.setState({ value: this.props.value })
    }

    componentDidUpdate(p) {
        if (p.value !== this.props.value && this.props.value !== this.state.value) this.setState({ value: this.props.value })
    }

    filterFromDateAdd = (icon, num, type) => {
        let toDate = moment(this.state.value, "YYYY-MM-DD").add(num, type);
        let extraText = "";
        if (type === "month") extraText = this.getMonthName(new Date(toDate));
        if (type === "year") extraText = new Date(toDate).getFullYear();

        return (<button
            style={{ margin: 5, display: "inline-block" }}
            onClick={() => {
                this.setState({ value: toDate ? moment(toDate).toDate() : moment().toDate() }, () => {
                    clearTimeout(this.changeRun)
                    this.changeRun = setTimeout(() => {
                        this.props.onChange(toDate)
                    }, 1000);
                })
            }}>
            {num > 0 ? extraText : ""}
            <Icon type={icon} />
            {num < 0 ? extraText : ""}
        </button>)
    }


    printDate(date: Date) {
        let str = this.getText(10032) + " ";
        str += this.getDayName(date);
        str += ", " + date.getDate();
        str += " " + this.getText(10040);
        str += this.getMonthName(date);
        str += ", " + date.getFullYear();

        return str;
    }


    getMonthName = (date) => {
        switch (date.getMonth()) {
            case 0: return this.getText(10041);
            case 1: return this.getText(10042);
            case 2: return this.getText(10043);
            case 3: return this.getText(10044);
            case 4: return this.getText(10045);
            case 5: return this.getText(10046);
            case 6: return this.getText(10047);
            case 7: return this.getText(10048);
            case 8: return this.getText(10049);
            case 9: return this.getText(10050);
            case 10: return this.getText(10051);
            case 11: return this.getText(10052);
        }
    }

    getDayName = (date) => {
        switch (date.getDay()) {
            case 0: return this.getText(10033);
            case 1: return this.getText(10034);
            case 2: return this.getText(10035);
            case 3: return this.getText(10036);
            case 4: return this.getText(10037);
            case 5: return this.getText(10038);
            case 6: return this.getText(10039);
        }
    }

    render() {
        return (<div>
            <h5 style={{ fontWeight: "bold", display: "inline-block" }}>
                <div>
                    {this.filterFromDateAdd("fast-forward", -1, 'year')}
                    {this.filterFromDateAdd("forward", -1, 'month')}
                    {this.filterFromDateAdd("backward", 1, 'month')}
                    {this.filterFromDateAdd("fast-backward", 1, 'year')}
                </div>
                <div>
                    {this.filterFromDateAdd("caret-right", -1, 'days')}
                    {this.printDate(this.state.value)}
                    {this.filterFromDateAdd("caret-left", 1, 'days')}
                </div>
            </h5>
        </div>)
    }
}

export default DashboardDateChecker;